
import { useSelector } from 'react-redux';
import CustomToolTip from '../../CommonComponents/CustomToolTip';
import { SBandAntennaSvg, SBandRadioSvg, UHFAntennaSvg, UHFRadioSvg, XBandAntennaSvg, XBandRadioSvg } from '../Svgs/CatalogSvgs';

const CommSlider = ({ blankTemplateData, enableBusSlider, selectedComp, setSelectedComp }) => {

    const CloneTemplate = useSelector((state: any) => state.catalog.CloneTemplate);

    const commItems = [
        {
            key: "S-Band Radio",
            icon: <SBandRadioSvg />,
            path: ["assembly", 0, "communication", "comm-devices", "S-band"],
        },
        {
            key: "S-Band Antenna",
            icon: <SBandAntennaSvg />,
            path: ["assembly", 0, "communication", "antennas", "S-band"],
        },
        {
            key: "X-Band Radio",
            icon: <XBandRadioSvg />,
            path: ["assembly", 0, "communication", "comm-devices", "X-band"],
        },
        {
            key: "X-Band Antenna",
            icon: <XBandAntennaSvg />,
            path: ["assembly", 0, "communication", "antennas", "X-band"],
        },
        {
            key: "K-Band Radio",
            icon: <XBandRadioSvg />,
            path: ["assembly", 0, "communication", "comm-devices", "X-band"],
        },
        {
            key: "K-Band Antenna",
            icon: <XBandAntennaSvg />,
            path: ["assembly", 0, "communication", "antennas", "X-band"],
        },
        {
            key: "UHF Radio",
            icon: <UHFRadioSvg />,
            path: ["assembly", 0, "communication", "comm-devices", "UHF"],
        },
        {
            key: "UHF Antenna",
            icon: <UHFAntennaSvg />,
            path: ["assembly", 0, "communication", "antennas", "UHF"],
        },
    ];

    //  Safe getter for deeply nested objects
    const getNested = (obj: any, path: (string | number)[]) => path.reduce((acc, key) => (acc ? acc[key] : undefined), obj);

    //  Render a single card
    const renderCard = ({ key, icon, path }: (typeof commItems)[0]) => {
        const cloneData = CloneTemplate["Comm"]?.[key];
        const blankData = getNested(blankTemplateData, [...path, "atmos-data"]);
        const numUnits = getNested(blankTemplateData, [...path, "user_data", "numUnits"]) || 0;
        const name = cloneData?.name || blankData?.name || "";

        return (
            <div
                key={key}
                className={`config-card ${selectedComp === key ? "active" : ""}`}
                onClick={() => {
                    setSelectedComp(key);
                    enableBusSlider(cloneData || blankData || {}, key, "Communication", numUnits);
                }}
            >
                <h5 className="c-color1">
                    {icon}
                    {key}
                </h5>
                <div className="text-truncate">
                    <CustomToolTip title={name} placement="top-start">
                        {name}
                    </CustomToolTip>
                </div>
            </div>
        );
    };

    return (
        <div className="config-data-box h-100">
            {commItems.map(renderCard)}
        </div>
    );

};
export default CommSlider;
